// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"b14ccd02","360":"7de868e5","388":"f7d617a1","722":"47aa3029","798":"8d981999","933":"cfcd65b0"}[chunkId] + ".chunk.js";
};